import React, {FunctionComponent} from 'react';
import {useParams, useSearchParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {Card, CardContent} from '@mui/material';
import {AppDispatch, RootState} from '../../store/store';
import {useTranslation} from 'react-i18next';
import {verifyWithToken} from './verify';
import './Verify.css';
import AppLayout from '../../layouts/AppLayout/AppLayout';
import useTitle from '../../helpers/use-title';
import {Container} from "@mui/system";
import {LoadingButton} from "@mui/lab";

const VerifyToken: FunctionComponent = () => {

  const { t } = useTranslation(['verify']);

  const dispatch = useDispatch<AppDispatch>();
  const loading = useSelector((state: RootState) => state.pages.verify.loading);

  const { token = '' } = useParams<{ token: string }>();

  const [searchParams] = useSearchParams();
  const searchParamsToken = searchParams.get( 'token' ) || '';


  useTitle(t('please-wait'));

  const onClick = () => {
    dispatch( verifyWithToken( token ? token : searchParamsToken ) );
  }

  return (
    <AppLayout title={t('your-account')}>
      <Container className={"settings-verify-token"}>
        <Card sx={{mt: 4}}>
          <CardContent>
            <h2>{t('verification-header')}</h2>
            <p>{t('verification-description')}</p>
            <LoadingButton
              loading={loading === 'pending'}
              variant='contained'
              onClick={onClick}>
              {t('verification-button')}
            </LoadingButton>
          </CardContent>
        </Card>
      </Container>
    </AppLayout>
  );
}

export default VerifyToken;
